const SLIDE_DURATION = 300;

export const handleFilterCardToggle = target => {
    const card = target.closest('.filter-card');

    if (!card) {
        return;
    }

    const body = card.querySelector('.body');

    if (target.checked) {
        card.classList.add('active');
        body.classList.remove('open-complete');
        body.hidden = false;

        const targetHeight = body.offsetHeight;

        body.style.maxHeight     = '0px';
        body.style.paddingBlock  = '0px';
        body.style.borderTopWidth = '0px';

        requestAnimationFrame(() => {
            body.style.maxHeight     = `${targetHeight}px`;
            body.style.paddingBlock  = '';
            body.style.borderTopWidth = '';
        });

        setTimeout(() => {
            body.style.maxHeight = 'none';
            body.classList.add('open-complete');
        }, SLIDE_DURATION);
    } else {
        card.classList.remove('active');
        body.classList.remove('open-complete');
        body.style.maxHeight = `${body.scrollHeight}px`;

        requestAnimationFrame(() => {
            body.style.maxHeight     = '0px';
            body.style.paddingBlock  = '0px';
            body.style.borderTopWidth = '0px';
        });

        setTimeout(() => {
            body.hidden = true;
            body.style.maxHeight     = '';
            body.style.paddingBlock  = '';
            body.style.borderTopWidth = '';
        }, SLIDE_DURATION);
    }
};

export const handleFilterCardModeChange = target => {
    const card = target.closest('.filter-card');

    if (!card) {
        return;
    }

    const hint       = card.querySelector('.hint');
    const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1);

    hint.textContent = card.dataset[`hint${capitalize(target.value)}`] ?? '';
};
